export type some = { [key: string]: any };

type CA_ID = 1 | 17;

export const CA_ID: CA_ID = 17;

export const MT_ID: CA_ID = 17;

export const DEV = process.env.NODE_ENV === 'development';
// export const DEV = true;

export const TEST =
  window.location.hostname.startsWith('mytour.tripi') ||
  window.location.hostname.indexOf('-dev.') >= 0;

export const STAGING = window.location.hostname.startsWith('stage.');

export const SUCCESS_CODE = 200;

export const TOKEN = 'token';

export const PAGE_SIZE = 10;

export const ROW_PER_PAGE = [10, 20, 30, 50];

export const TABLET_WIDTH_NUM = 1024;
export const MIN_TABLET_WIDTH_NUM = 750;
export const MOBILE_WIDTH_NUM = 480;
export const DESKTOP_WIDTH_NUM = 1260;

export const APP_ID = 'com.tripi.crm';

export const HASH_KEY =
  TEST || STAGING || DEV ? 'kaa1231234assszfqqxavvgraxzsaffga' : 'zgYDZSgZTr8E3Rv6yZetCSrtv4DAKA';
export const KEY_GOOGLE_MAP = 'AIzaSyCktZ4VE5hoHILLG6N2M7XxCt-Zlq6HsdI';

export const genderOptions = [
  { id: 0, name: 'male' },
  { id: 1, name: 'female' },
];

export const dayOptions = [
  { id: 0, name: 'Mon', nameVi: 'T2' },
  { id: 1, name: 'Tue', nameVi: 'T3' },
  { id: 2, name: 'Wed', nameVi: 'T4' },
  { id: 3, name: 'Thu', nameVi: 'T5' },
  { id: 4, name: 'Fri', nameVi: 'T6' },
  { id: 5, name: 'Sat', nameVi: 'T7' },
  { id: 6, name: 'Sun', nameVi: 'CN' },
];

export const MIX_PANEL_KEY = '32a0dc4f2272b6d133d89c41389ca642';

export const MIX_PANEL_TRACK = {
  SEARCH_CLICK: 'SEARCH_CLICK',
  SEARCH_EVENT: 'SEARCH_EVENT',
  VISIT_HOME: 'VISIT_HOME',
  VISIT_DETAIL_RESTAURANT: 'VISIT_DETAIL_RESTAURANT',
  VISIT_LIST_RESTAURANT: 'VISIT_LIST_RESTAURANT',
  CLICK_FILTER_NEARLY: 'CLICK_FILTER_NEARLY',
  CLICK_FILTER_CORRECTLY: 'CLICK_FILTER_CORRECTLY',
  CLICK_FILTER_RATING: 'CLICK_FILTER_RATING',
  CLICK_FILTER_POPULAR: 'CLICK_FILTER_POPULAR',
  CLICK_FILTER_MOST_VIEW: 'CLICK_FILTER_MOST_VIEW',
};
